<div class="row rm-footer space-margin" [ngStyle]="getFirstStyles()"> 
    <div class="col-md-12">
        {{pw}}
      </div>

  </div>

 